import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

import state from "./state";
import * as getters from './getter';
import * as mutations from './mutation';
import * as actions from './action';

import auth from './modules/auth';
import template from './modules/template';
import collection from './modules/collection';
import charset from './modules/charset';
import detect from './modules/detect';
import ocr from './modules/ocr';
import engine from './modules/engine';
import admin_user from './modules/admin_user';
import assignment from './modules/assignment';
import admin_organizations from './modules/admin_organizations';
import admin_stats from './modules/admin_stats';
import home from './modules/home';
import user from './modules/user';
import device from "./modules/device";

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,


  modules: {
    auth,
    template,
    collection,
    charset,
    detect,
    ocr,
    engine,
    admin_user,
    assignment,
    admin_organizations,
    admin_stats,
    home,
    user,
    device
  },

  plugins: [createPersistedState({
    paths: [
      'collection.collection.id',
      'collection.collection.type',
      'template.template.id',
      'template.template.is_assignment',
      'template.template.is_instant',
      'template.batch.id',
      "home",
      "auth",
      "user"
    ]
  })],
});
